module.exports = __webpack_public_path__ + "static/media/zuitt-logo.ce0167f1.png";